<template>
  <div class="container-fluid" style="background-color:white !important;">
    <Header />
    <transition name="slide" mode="out-in">
      <router-view></router-view>
    </transition>
    <Footer />
  </div>
</template>

<script>
import Header from "./components/Header";
import Slider from "./components/Slider";
import Homepage from "./components/Homepage";
import Footer from "./components/Footer";

export default {
  data() {
    return {
      color: "#4FCA3E",
      types: ["points", "circles"]
    };
  },
  components: {
    Header,
    Slider,
    Footer,
    Homepage
  },
  methods: {
    openLoading(time) {
      const loading = this.$vs.loading({
        type: this.types[1],
        color: this.color,
        background:"#111",
        text : "AYANCIK ADAK",
        scale:"1.5"
      });
      setTimeout(() => {
        loading.close();
      }, time);
    }
  },
  created() {
    this.openLoading(1500);
  },
  beforeUpdate() {
    this.openLoading(1000);
  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@400&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Quicksand:wght@600&display=swap");
* {
  font-family: "Quicksand", sans-serif;
}

.slide-enter {
  opacity: 0;
}
.slide-enter-active {
  /* animation: slide-in 1s ease-out forwards; */
  transition: opacity 0.5s;
}

.slide-leave-active {
  /* animation: slide-out 1s ease-out forwards; */
  transition: opacity 1s;
  opacity: 0;
}
@keyframes slide-in {
  from {
    transform: translateY(20px);
  }
  to {
    transform: translateY(0px);
  }
}

@keyframes slide-out {
  from {
    transform: translateY(0px);
  }
  to {
    transform: translateY(20px);
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue